import { RIGHTS } from 'core-uda/Rights'
import { hasYamlRight } from './deprecatedLayers.utils'

export function deprecatedHybridLayer() {
  if (hasYamlRight('hybrid')) return {}

  const hybridUrl = RIGHTS('map.layers.hybrid.url', '')

  if (!hybridUrl) return {}

  const centerZoomFactor = RIGHTS('map.layers.zoomFactor', 1),
    options: {
      type: string
      url: any
      data: {
        icon: string
      }
      maxZoom: number
      zoomFactor: number
      maxZoomBeforeStretching?: number
    } = {
      type: 'tileXYZ',
      url: hybridUrl,
      data: { icon: 'hybrid' },
      maxZoom: 19 * centerZoomFactor,
      zoomFactor: centerZoomFactor === 1 ? 2 : 1.5,
      maxZoomBeforeStretching: undefined,
    }

  if (hybridUrl.indexOf('BING') > -1) {
    options.type = hybridUrl
    options.maxZoomBeforeStretching = Number.parseInt(
      RIGHTS('map.layers.hybrid.bingMaxZoom', 19),
    )
  }

  return options
}
